/**
 * Tutti i pacchetti del sito. Modifica/aggiungi/rimuovi qui sotto.
 */
export const PACKAGES = [
  {
    id: "tenerife",
    destination: "Tenerife",
    country: "Spagna",
    flag: "🇪🇸",
    emoji: "🌋",
    nights: "5 notti",
    price: 199.99,
    period: "Giugno · Luglio · Agosto",
    image: "https://images.unsplash.com/photo-1578784088143-c18da1a91336?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Bestseller",
    includes: [
      "Volo A/R incluso",
      "Hotel pieno centro – zona Las Americas",
      "Colazione inclusa",
      "1 zaino + 1 bagaglio stiva 10kg a persona",
      "Assicurazione volo + medica",
    ],
    description: "Sole, oceano e vibes spagnole nel cuore di Las Americas.",
    order: 1,
  },
  {
    id: "sharm",
    destination: "Sharm El-Sheikh",
    country: "Egitto",
    flag: "🇪🇬",
    emoji: "🐪",
    nights: "7 notti",
    price: 249.99,
    period: "Giugno · Luglio · Agosto",
    image: "https://images.unsplash.com/photo-1549294413-26f195200c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Pensione Completa",
    includes: [
      "Volo A/R",
      "Resort con piscina + accesso spiaggia",
      "Pensione completa",
      "Transfer aeroporto-resort incluso",
      "Bagaglio a mano 10kg + zaino",
      "Tasse e assicurazione incluse",
    ],
    description: "Mar Rosso, snorkeling e resort 4★ con tutto incluso.",
    order: 2,
  },
  {
    id: "ibiza",
    destination: "Ibiza",
    country: "Spagna",
    flag: "🇪🇸",
    emoji: "🎧",
    nights: "6 notti",
    price: 219.99,
    period: "Giugno · Luglio · Agosto",
    image: "https://images.unsplash.com/photo-1642445624042-6e874ab1a5ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Trendy",
    includes: [
      "Volo A/R + Hotel",
      "Tasse aeroportuali incluse",
      "Bagaglio incluso",
      "Assistenza dedicata",
    ],
    description: "L'isola bianca: tramonti infiniti, beach club e party leggendari.",
    order: 3,
  },
  {
    id: "mykonos",
    destination: "Mykonos",
    country: "Grecia",
    flag: "🇬🇷",
    emoji: "🧿",
    nights: "7 notti",
    price: 269.99,
    period: "Giugno · Luglio · Agosto",
    image: "https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Premium",
    includes: [
      "Volo A/R + Hotel",
      "Tasse incluse",
      "Bagaglio incluso",
      "Hotel selezionati",
    ],
    description: "Casette bianche, mare cristallino e l'energia delle Cicladi.",
    order: 4,
  },
  {
    id: "marbella",
    destination: "Marbella",
    country: "Spagna",
    flag: "🇪🇸",
    emoji: "🥂",
    nights: "7 notti",
    price: 239.99,
    period: "Aprile · Maggio · Giugno",
    image: "https://images.unsplash.com/photo-1570698473651-b2de99bae12f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Glam",
    includes: [
      "Volo A/R Italia – Malaga",
      "Hotel centrale con piscina, vicino alla spiaggia",
      "Colazione inclusa",
      "Transfer aeroporto-hotel A/R incluso",
      "1 zaino + 1 bagaglio 10kg a persona",
      "Assicurazione volo + medica",
    ],
    description: "La Costa del Sol più chic: yacht, paseo e tramonti dorati.",
    order: 5,
  },
  {
    id: "madrid",
    destination: "Madrid",
    country: "Spagna",
    flag: "🇪🇸",
    emoji: "⛪",
    nights: "3 notti",
    price: 149.99,
    period: "Pasqua · Aprile",
    image: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Pasqua",
    includes: [
      "Volo A/R + Hotel",
      "City break a Pasqua",
      "Bagaglio incluso",
      "Tasse incluse",
    ],
    description: "Tapas, arte e movida nel cuore della Spagna.",
    order: 6,
  },
  {
    id: "barcellona",
    destination: "Barcellona",
    country: "Spagna",
    flag: "🇪🇸",
    emoji: "🏛️",
    nights: "3 notti",
    price: 149.99,
    period: "Pasqua · Aprile",
    image: "https://images.unsplash.com/photo-1583422409516-2895a77efded?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Pasqua",
    includes: [
      "Volo A/R + Hotel",
      "City break a Pasqua",
      "Bagaglio incluso",
      "Tasse incluse",
    ],
    description: "Gaudí, mare e tapas: la città che non dorme mai.",
    order: 7,
  },
  {
    id: "miami",
    destination: "Miami",
    country: "USA",
    flag: "🇺🇸",
    emoji: "🛥️",
    nights: "7 notti",
    price: 899.0,
    period: "Tutto l'anno",
    image: "https://images.unsplash.com/photo-1563271978-de56ca503913?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Premium USA",
    includes: [
      "Volo A/R Italia – Miami",
      "Hotel a South Beach",
      "Bagaglio in stiva incluso",
      "Assicurazione viaggio premium",
      "Assistenza 24/7",
    ],
    description: "South Beach, art deco e l'America più glamour.",
    order: 8,
  },
  {
    id: "maldive",
    destination: "Maldive",
    country: "Maldive",
    flag: "🇲🇻",
    emoji: "🏝️",
    nights: "7 notti",
    price: 1499.0,
    period: "Tutto l'anno",
    image: "https://images.unsplash.com/photo-1540541338287-41700207dee6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    badge: "Luxury",
    includes: [
      "Volo A/R + Resort overwater",
      "Pensione completa",
      "Transfer in idrovolante",
      "Assicurazione premium",
    ],
    description: "Bungalow sull'acqua, barriera corallina e silenzio assoluto.",
    order: 9,
  },
];
